import { LoadableComponentMethods } from '@loadable/component';
import { memo } from 'react';
import classes from 'classnames';
import { useTranslation } from 'react-i18next';
import LogoutButton from '@/components/LogoutButton/LogoutButton';
import * as R from '@/Router/routes';
import { AsyncActiveLoan } from '@/pages/ActiveLoan/async';
import ChevronIcon from '@/assets/icons/chevron-sharp.svg?react';
import Logo from '@/assets/icons/logo.svg?react';
import Link from '@/components/Link/Link';
import styles from './DesktopHeader.module.scss';

export type Props = {
  backUrl?: string;
  backPreload?: LoadableComponentMethods<unknown>['preload'];
  withLogout?: boolean;
  className?: string;
  logoLinkUrl?: string;
  homePreload?: LoadableComponentMethods<unknown>['preload'];
};

const DesktopHeaderMemo = memo(function DesktopHeader({
  backUrl,
  backPreload,
  withLogout,
  className,
  logoLinkUrl = R.ACTIVE_LOAN,
  homePreload = AsyncActiveLoan.preload,
}: Props) {
  const { t } = useTranslation('desktop_header');

  const preload = () => {
    backPreload?.();
  };
  const preloadHomepage = () => {
    homePreload?.();
  };

  return (
    <header
      className={classes(styles.header, className)}
      data-test="desktopHeader-header"
    >
      <div className={styles.item}>
        {backUrl && (
          <Link
            className={styles.backLink}
            dataTest="flow-back"
            to={backUrl}
            onMouseEnter={preload}
          >
            <ChevronIcon
              className={styles.chevron}
              data-test="desktopHeader-chevron-icon"
            />
            <span data-test="desktopHeader-back-text">{t('back')}</span>
          </Link>
        )}
      </div>
      <div className={classes(styles.item, styles.center)}>
        <Link
          to={logoLinkUrl}
          onMouseEnter={preloadHomepage}
          dataTest="desktop-back-link"
        >
          <Logo />
        </Link>
      </div>
      <div className={classes(styles.item, styles.right)}>
        {withLogout && <LogoutButton />}
      </div>
    </header>
  );
});

export default DesktopHeaderMemo;
